import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import {
  client,
  HTTPValidationError,
  nonDicomFileStudiesSiteNonDicomFileGet,
  NonDicomFileStudiesSiteNonDicomFileGetResponse,
} from '@common/config/api/client'

export interface NonDicomFileUrlParams {
  studyId: string
  subjectId: string
  timepointSubmissionId: string
  containerSubmissionId: string
  examMetadataId: string
}

export const nonDicomFileQueryKey = (params: NonDicomFileUrlParams) => ['NonDicomFile', params.examMetadataId]

export const useNonDicomFileUrl = (
  params: NonDicomFileUrlParams | undefined,
  enabled: boolean,
): UseQueryResult<NonDicomFileStudiesSiteNonDicomFileGetResponse, AxiosError<HTTPValidationError>> => {
  return useQuery<NonDicomFileStudiesSiteNonDicomFileGetResponse, AxiosError<HTTPValidationError>>({
    queryKey: params ? nonDicomFileQueryKey(params) : ['NonDicomFile'],
    enabled: enabled && !!params,
    // The URL is short lived, so never serve a cached one that may already have expired
    gcTime: 0,
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      if (!params) {
        throw new Error('Missing parameters for non-DICOM file request')
      }
      const response = await nonDicomFileStudiesSiteNonDicomFileGet({
        client,
        query: {
          study_id: params.studyId,
          subject_id: params.subjectId,
          timepoint_submission_id: params.timepointSubmissionId,
          container_submission_id: params.containerSubmissionId,
          exam_metadata_id: params.examMetadataId,
        },
        throwOnError: true,
      })
      return response.data
    },
  })
}
